import React from "react";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import SocialMedia from "./SocialMedia";

const SocialMediaSection = (props: any) => {
    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName="users" />
                        </div>
                        <div className="box-title-text">
                            <h2 className="box-title">Social Media</h2>
                        </div>
                    </div>
                    <div className="box-description">
                        <p>
                            Your online posts reflect you- Prospective employers, college admissions officials, colleagues, current employers, and peers often make
                            inferences about you based on your social media content. We analyze your facebook, Instagram, LinkedIn and X accounts to indicate
                            how the world sees your online identity.
                        </p>
                    </div>
                </div>
                <div className="box-content">
                    <div role="grid" className="data-grid has-lines row-height-md margin-top-l">
                        <SocialMedia socialMediaNetwork={"Facebook"} socialMediaNetworkID={1} />
                        <SocialMedia socialMediaNetwork={"Instagram"} socialMediaNetworkID={4} />
                        {/*<SocialMedia socialMediaNetwork={"LinkedIn"} socialMediaNetworkID={3} />*/}
                        <SocialMedia socialMediaNetwork={"X"} socialMediaNetworkID={2} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default SocialMediaSection;
